import { classNames } from 'libs/react';
import { Icon } from './Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './Badge.scss';
/**
 * @component Badge
 * @since 1.0.0
 */
export function Badge(props) {
    const { style, label, picto } = Object.assign({ style: 'normal' }, props);
    const className = classNames('badge', 'badge--' + style, { 'badge--has-label': label }, { 'badge--has-picto': picto }, props.className);
    return (React.createElement("div", { className: className },
        picto && React.createElement(Icon, { className: "badge-picto", value: picto }),
        label && React.createElement(Text, { className: "badge-label", value: label })));
}
